import { render, staticRenderFns } from "./EntrepreneursList.vue?vue&type=template&id=0b6d5704&scoped=true&"
import script from "./EntrepreneursList.vue?vue&type=script&lang=js&"
export * from "./EntrepreneursList.vue?vue&type=script&lang=js&"
import style0 from "./EntrepreneursList.vue?vue&type=style&index=0&id=0b6d5704&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b6d5704",
  null
  
)

export default component.exports